import * as types from '../actionTypes/lookupCodeType'

let defaultState={
    lookupCodeTypes: []
}

const lookupCodeTypeReducer=(state = defaultState, action) => {
    if (action.type === types.GET_LOOKUP_CODE_TYPES){
        return{
            ...state,
            lookupCodeTypes: action.lookupCodeTypes
        }
    }   
    else {
        return{
            ...state
        }
    }
}

export default lookupCodeTypeReducer;


// WEBPACK FOOTER //
// ./src/reducers/lookupCodeType.js